import { useAuth } from '@/contexts/AuthContext';

/**
 * Returns the user's stored IANA timezone (e.g. "Europe/Stockholm").
 * Falls back to the browser's current timezone if the profile value is not yet set.
 */
export function useUserTimezone(): string {
  const { user } = useAuth();
  return user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
}
